import type { SVGProps } from "react";
import { Folder } from "lucide-react";

export function ProjectsIcon(props: SVGProps<SVGSVGElement>) {
  return <Folder color="currentColor" {...props} className={`w-5 h-5 ${props.className ?? ""}`} />;
}
